module.exports = __webpack_public_path__ + "img/report_system.19bc9865.jpg";